import { forwardRef } from 'react'
import { useView } from '@10000/react'
import { AutoScroll, Body, Box, Icon } from '../../widgets'
import { Participant } from './'
import { assetUrl } from '../../../utilities.js'
import './ParticipantList.scss'

export const ParticipantList = forwardRef(function ParticipantList({ controls = true, autoScroll }, ref) {
  const { sortedParticipants = [], clientId, questionIndex, question, playersAnswered, stage, options: { kiosk, presenterParticipates, solo } = {} } = useView('squiz')

  return <Box column className="participant-list-container" fullWidth fullHeight>
    <Box column fullHeight>
      <Box gap={4} alignItems="center" justifyContent="start" fullWidth>
        <Icon icon="Team" size={24}/>
        <Body>
          {questionIndex > -1 && `${playersAnswered}/`}{sortedParticipants.length} TEAM MEMBER{sortedParticipants.length !== 1 && 'S'}
        </Body>
      </Box>

      {sortedParticipants.length === 0 && <Participant />}

      <AutoScroll scrollTime={autoScroll ? sortedParticipants.length * 250 : 0} style={{ height: '100%' }}>
        <Box fullWidth column gap={8} overflowY={!autoScroll && 'auto'} fullHeight>
          <Box ref={ref} column gap={8} r={30}>
            {sortedParticipants.map(user =>
              <Participant
                key={user.index}
                index={user.index}
                name={user.name}
                avatar={user.avatar}
                isCurrentUser={user.clientId === clientId}
                isPresenter={user.clientId === clientId}
                controls={controls}
                answered={stage === 'consensus' ? user.consensusLockedIn : (user.answers?.[question] !== null && questionIndex > -1)}
              />
            )}
          </Box>
          {((sortedParticipants.length === 0 || ((kiosk || presenterParticipates) && sortedParticipants.length === 1)) && !solo) &&
            <Box gap={20} alignItems="center" column>
              <img src={assetUrl('gifs/waiting.gif')} alt="picasso hand" height={80} width={80} />
              <Body alt bold align="center" className="blink">Waiting on team members to join...</Body>
            </Box>
          }
        </Box>
      </AutoScroll>
    </Box>
  </Box>
})